// action types

export default {
  state: {},
  getters: {},
  actions: {},
  mutations: {},
};
